import { Component, HostListener, Input, OnInit, AfterViewInit, ViewChild, ElementRef, OnChanges, SimpleChanges, ChangeDetectorRef, ViewChildren, QueryList, Output, EventEmitter } from '@angular/core';
import { GlobalVariables } from '../data/global-variables';
import { BookService } from '../services/book.service';
import { ConfigService } from '../services/config.service';
import { ImagesCacheService } from '../services/images-cache.service';
import { HistoricToolDataService } from '../services/historic-tool-data.service';
import { DrawingTools, ExpandableTool, PanZoomTools, ROITools, RotationTools, SpineTools, WindowingTools } from '../utils/expandableTools';
import { CornerstoneLiteDirective } from './cornerstone-lite.directive';
import { ToolSynchronizerService } from './tool-synchronizer.service';
import * as Hammer from 'hammerjs';
import { VisorContextMenuComponent } from '../utils/visor-context-menu/visor-context-menu.component';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { TourService } from '../services/tour.service';
import { event } from 'jquery';
import { Subscription } from 'rxjs';
import { BookImage } from '../data/book';
import Shepherd from 'shepherd.js';
import { CornerstoneTools } from '../utils/cornerstoneToolsDict';

@Component({
  selector: 'app-floating-visor',
  templateUrl: './floating-visor.component.html',
  styleUrls: ['./floating-visor.component.css'],
})
export class FloatingVisorComponent implements OnInit, AfterViewInit {

  @ViewChildren(CornerstoneLiteDirective) cornerstoneDirectivesQueryList!: QueryList<CornerstoneLiteDirective>;
  cornerstoneDirectives!: CornerstoneLiteDirective[];
  @ViewChild('Container') container!: ElementRef;
  @ViewChild(VisorContextMenuComponent) contextMenu!: VisorContextMenuComponent;

  HistoricToolDataService = HistoricToolDataService.getInstance();

  @Input('width') public width!: number;
  @Input('height') public height!: number;
  @Input('left') public left!: number;
  @Input('top') public top!: number;
  @Input() showWindowingTool!: boolean;

  @Output() navigatedSerie = new EventEmitter<'next' | 'prev'>();

  @Output("addLastStep") addLastTourStepEmitter = new EventEmitter<void>();
  @Output("closeVisor") closeVisorEmitter = new EventEmitter<void>();

  get isOpen() {
    return !(this.container.nativeElement.style.display == 'none');
  }


  //subscription: Subscription; // Observer para poder abrir y cerrar los menús de opciones desde el tour

  mouse: { x: number, y: number } = { x: 0, y: 0 };
  isResizing = false;
  isDragging = false;
  advancedMode = false;
  public expandableTools: ExpandableTool[] = [];
  _isLocked = false;
  auxClickOrigin = { x: 0, y: 0, time: 0 };

  //activeTour = false; //Variable para saber si hay un tour activo o no
  //firstVisorStep = false;

  get isLayoutActive() { return this.layout.rows != 1 && this.layout.columns != 1 };
  layout: { rows: number, columns: number } = { rows: 1, columns: 1 };

  get isPageSmall() {
    return this.globalVariables.isPageSmall;
  }

  get hasNext(): boolean {
    if (this.isLocked) return false;
    if (this.cornerstoneDirectives != null) {
      return this.cornerstoneDirectives[0]?.hasNext();
    }
    return false;
  }

  get hasPrev(): boolean {
    if (this.isLocked) return false;
    if (this.cornerstoneDirectives != null) {
      return this.cornerstoneDirectives[0]?.hasPrev();
    }
    return false;
  }

  get isLocked(): boolean {
    if (this.cornerstoneDirectives != null && (this.cornerstoneDirectives[0]?.hasPrev() || this.cornerstoneDirectives[0]?.hasNext())) {
      return this._isLocked;
    } else {
      return false;
    }
  }
  set isLocked(locked: boolean) {
    if (this.cornerstoneDirectives != null && (this.cornerstoneDirectives[0]?.hasPrev() || this.cornerstoneDirectives[0]?.hasNext())) {
      this._isLocked = locked;
    }
  }


  get loadedImages(): number | null {
    if (this.cornerstoneDirectives != null) {
      return this.cornerstoneDirectives[0]?.imageList?.length;
    }
    return null;
  }

  get currentImage(): string | null {
    if (this.cornerstoneDirectives != null) {
      return this.cornerstoneDirectives[0]?.currentImage?.imageId;
    }
    return null;
  }

  get currentPNGImage(): string | SafeUrl | null {
    if (this.cornerstoneDirectives != null && this.cornerstoneDirectives[0]?.imageList != null) {
      const png = this.cornerstoneDirectives[0]?.imageList[this.cornerstoneDirectives[0].currentIndex]?.png;
      if (png != null) {
        return this.sanitizer.bypassSecurityTrustUrl(png);
      }
    }
    return null;
  }

  get currentIndex(): number | null {
    if (this.cornerstoneDirectives != null) {
      return this.cornerstoneDirectives[0]?.currentIndex;
    }
    return null;
  }

  @HostListener('wheel', ['$event'])
  onMouseWheel(event: MouseEvent) {
    this.cornerstoneDirectives[0].onMouseWheel(event);
    // event.preventDefault();
    // if (this.isPlayingClip) {
    //   this.stopClip();
    //   return;
    // }
    // if (this.stackScrollMouseWheelEnabled) {
    //   if (this.imageList.length > 0 && !this.isPlayingClip) {
    //     const delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));
    //     if (delta > 0) {
    //       this.navigatedSerie.emit('next')
    //     } else {
    //       this.navigatedSerie.emit('prev')
    //     }
    //   }
    // }
    document.dispatchEvent(new Event('dicomViewer:scrolledImage'))
  }

  @HostListener('window:mousemove', ['$event'])
  @HostListener('window:touchmove', ['$event'])
  onMouseMove(event: MouseEvent | TouchEvent) {
    if (this.isResizing) {
      if (event instanceof MouseEvent) {
        this.width = event.clientX - this.left + 15;
        this.height = event.clientY - this.top + 15;
      }
      if (event instanceof TouchEvent) {
        this.width = event.touches[0].clientX - this.left + 15;
        this.height = event.touches[0].clientY - this.top + 15;
      }

      this.sanitizeLocation();
      window.dispatchEvent(new Event('resize'));
    }
    if (this.isDragging) {
      console.log(event);

      if (event instanceof MouseEvent) {
        // this.left = event.clientX - (this.width / 2 - 25);
        // this.top = event.clientY - 15;
        this.left += event.movementX
        this.top += event.movementY
      }
      if (event instanceof TouchEvent) {
        this.left = event.touches[0].clientX - (this.width / 2 - 25);
        this.top = event.touches[0].clientY - 15;
      }

      this.sanitizeLocation();
    }
  }

  @HostListener('window:mouseup', ['$event'])
  @HostListener('window:touchend', ['$event'])
  onMouseUp(event: MouseEvent) {
    this.isResizing = false
    this.isDragging = false
  }

  @HostListener('document:keydown', ['$event'])
  handleShortcutEvent(event: KeyboardEvent) {
    if (event.ctrlKey && event.key == 'z') {
      this.HistoricToolDataService.restoreLastDeletedTool();
      return false;
    }
    return;
  }

  constructor(
    public tourService: TourService,
    private cdr: ChangeDetectorRef,
    private globalVariables: GlobalVariables,
    private toolSynchronizer: ToolSynchronizerService,
    private bookService: BookService,
    private configService: ConfigService,
    public imagesCacheService: ImagesCacheService,
    private sanitizer: DomSanitizer
  ) {

    /*this.subscription = this.tourService.observable$.subscribe((n) => {

      this.collapseTools()

      switch (n) {
        case 1: {
          this.showExpandableTool(WindowingTools);
          break;
        }
        case 2: {
          this.showExpandableTool(RotationTools);
          break;
        }
        case 3: {
          this.showExpandableTool(PanZoomTools);
          break;
        }
        case 4: {

          this.showExpandableTool(ROITools);
          break;
        }
        case 5: {
          
            if (this.bookService.currentBook != null) {
              if (this.bookService.currentBook.pages[1].bookImages[0].dicomFile != null) {

                //Obtenemos el instance de la imagen, para poder abrirla en el visor
                let str = this.bookService.currentBook.pages[1].bookImages[0].dicomFile;
                let lastSlashIndex = str.lastIndexOf('/');
                let dcmIndex = str.lastIndexOf('.dcm');
                let instanceUID = str.substring(lastSlashIndex + 1, dcmIndex);

                this.loadImage(this.bookService.currentBook?.studyUIDs[0], instanceUID);
                this.activateAdvancedMode();
              }
            }

          break;
        }
        case 6: {
          this.hide()
          break;
        }
        case 7: {
          this.firstVisorStep = true;
          break;
        }
        case 8: {
          this.firstVisorStep = false;
          break;
        }
        default: {
          this.collapseTools()
        }
      }
    })*/
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.cornerstoneDirectives = [...this.cornerstoneDirectivesQueryList.toArray()];
    this.cornerstoneDirectivesQueryList.changes.subscribe(directives => {
      this.cornerstoneDirectives = [...directives];
    })

    const resizeObserver = new ResizeObserver(() => {
      if (this.isOpen)
        window.dispatchEvent(new Event('resize'))
    });
    // El timeout es porque da error si se intenta poner de primeras
    setTimeout(() => {
      resizeObserver.observe(this.container.nativeElement);
    }, 1000);

  }

  sanitizeLocation() {
    this.width = Math.min(this.width, document.body.clientWidth - 10);
    this.width = Math.max(this.width, 150);

    this.height = Math.min(this.height, document.body.clientHeight - 10);
    this.height = Math.max(this.height, 150);

    this.left = Math.max(this.left, 0);
    if (this.left + this.width > document.body.clientWidth) {
      this.left = document.body.clientWidth - this.width;
    }

    this.top = Math.max(this.top, 0);
    if (this.top + this.height > document.body.clientHeight) {
      this.top = document.body.clientHeight - this.height;
    }

    if (this.left + this.width > document.body.clientWidth) {
      this.width = document.body.clientWidth - this.left;
    }

    if (this.top + this.height > document.body.clientHeight) {
      this.height = document.body.clientHeight - this.top;
    }
  }

  startResizing() {
    this.isResizing = true;
  }

  startDragging(event: Event) {
    if ((event.target as any).id == 'top-banner') {
      this.isDragging = true;
    }
  }

  nextImage() {
    this.cornerstoneDirectives.forEach(d => {
      if (this.hasNext) {
        d.nextImage();
        this.navigatedSerie.emit('next');
      }
    })
  }

  prevImage() {
    this.cornerstoneDirectives.forEach(d => {
      if (this.hasPrev) {
        d.prevImage();
      }
      this.navigatedSerie.emit('prev');
    })
  }

  jumpToIndex(i: number) {
    this.cornerstoneDirectives.forEach((d, index) => {
      d.jumpToIndex(i + index);
    });
  }

  // jumpToImage(instanceUID: string): boolean {
  //   if (instanceUID == null || instanceUID.trim() == '') {
  //     return false;
  //   }
  //   const index = this.cornerstoneDirectives[0].imageList.findIndex(im => im.data.string('x00080018') == instanceUID);
  //   if (index == -1) {
  //     return false
  //   } else {
  //     this.jumpToIndex(index);
  //     return true;
  //   }
  // }

  // Solo para visor avanzado
  enableTool(button: number, toolName: string) {
    this.cornerstoneDirectives.forEach(d => {
      if (!this.isLayoutActive) {
        d.activateTool(toolName, button);
      } else {
        // Con el de Pan debería sincronizarse también zoom
        if (toolName == 'Pan') {
          d.activateTool('Pan', button, this.toolSynchronizer.getSynchronizerForTool('Pan'));
        }
        if (toolName == 'Wwwc') {
          d.activateTool('Wwwc', button, this.toolSynchronizer.getSynchronizerForTool('Wwwc'));
        } else {
          d.activateTool(toolName, button);
        }
      }
    })
  }

  // activateTools() {
  //   if (this.advancedMode) {
  //     this.enableTool(2, 'Pan');
  //     this.enableTool(1, 'Wwwc');
  //     this.cornerstoneDirectives.forEach(d => {
  //       d.activateZoomWithMouseWheel();
  //       // d.activateScrollWithMouseWheel();
  //     })
  //   } else {
  //     this.cornerstoneDirectives.forEach(d => {
  //       const windowingBtn = (this.globalVariables.isPageSmall) ? 1 : 2;
  //       if (!this.isLayoutActive) {
  //         d.activateTool('Pan', 1);
  //         d.activateTool('Wwwc', windowingBtn);
  //       } else {
  //         // Con el de Pan debería sincronizarse también zoom
  //         d.activateTool('Pan', 1, this.toolSynchronizer.getSynchronizerForTool('Pan'));
  //         d.activateTool('Wwwc', windowingBtn, this.toolSynchronizer.getSynchronizerForTool('Wwwc'));
  //       }
  //       d.activateZoomWithMouseWheel();
  //     })
  //   }
  // }

  // loadImageFromRoute(studyUID: string, route: string): Promise<void> {
  //   return new Promise<void>((resolve, reject) => {

  //     // Suponemos una sola directiva Cornerstone
  //     const d = this.cornerstoneDirectives[0];
  //     d.loadSingleImage(studyUID, route).then(() => {
  //       this.activateTools();
  //       resolve();
  //       this.show();
  //     });
  //   });
  // }

  loadImage(studyUID: string, instance: string): Promise<void> {
    const urlParams = new URLSearchParams(window.location.search);
    const tkn = urlParams.get('tkn');
    return new Promise<void>((resolve, reject) => {
      try {
        this.imagesCacheService.buildURIs(studyUID, instance, tkn!).then(images => {
          // Suponemos una sola directiva Cornerstone
          const d = this.cornerstoneDirectives[0];
          d.setImages([images]);
          resolve();
          this.show();
        });
      } catch (error) {
        console.error(error)
        reject(error);
      }
    });
  }

  loadSerie(studyUID: string, instances: string[]): Promise<void> {
    const urlParams = new URLSearchParams(window.location.search);
    const tkn = urlParams.get('tkn');
    return new Promise<void>((resolve, reject) => {
      try {
        // Suponemos una sola directiva Cornerstone
        const d = this.cornerstoneDirectives[0];
        this.imagesCacheService.buildAllURIs(studyUID, instances, tkn!).then(images => {
          d.setImages(images);
          resolve();
          this.show();
        })
        // Suponemos una sola directiva Cornerstone
        // const d = this.cornerstoneDirectives[0];
        // d.loadSingleImage(studyUID, route).then(() => {
        //   this.activateTools();
        //   resolve();
        //   this.show();
        // });
      } catch (error) {
        console.error(error)
        reject(error);
      }
    });
  }

  // loadComplementaryImages(studyUID: string, route: string): Promise<void> {
  //   this.cornerstoneDirectives.forEach(d => {
  //     d.activateScrollWithMouseWheel();
  //   });
  //   return new Promise<void>((resolve, reject) => {
  //     // Suponemos una sola directiva Cornerstone
  //     const d = this.cornerstoneDirectives[0];

  //     this.configService.surrounding_images.then(numberOfSurroundingImages => {
  //       let imagesToLoad = this.bookService.getSurroundingImages(route, numberOfSurroundingImages);
  //       d.loadComplementaryImages(studyUID, imagesToLoad).then(() => {
  //         resolve();
  //       });
  //     })
  //   });
  // }

  // loadOneMoreImage(studyUID: string, route: string): Promise<void> {
  //   console.log('Buscando imagen: ', route);

  //   return new Promise<void>((resolve, reject) => {
  //     // Suponemos una sola directiva Cornerstone
  //     const d = this.cornerstoneDirectives[0];

  //     d.loadComplementaryImages(studyUID, [route]).then(() => {
  //       resolve();
  //     });
  //   });
  // }

  // loadSerieFromRoutes(routes: string[], highlightedImages: string[] = []): Promise<void> {
  //   return new Promise<void>((resolve, reject) => {
  //     const promises: Promise<void>[] = [];
  //     promises.push(new Promise((resolveAux, rejectAux) => {
  //       this.cornerstoneDirectives.forEach((d, index) => {
  //         d.loadSerie(routes).then((imageIds) => {
  //           this.toolSynchronizer.addToSynchronizer({ imageIds }, d.element);
  //           this.activateTools();

  //           resolveAux();
  //           d.jumpToIndex(index);
  //         }).catch(() => rejectAux());
  //       })
  //     }));
  //     Promise.all(promises).then(() => {
  //       resolve();
  //       this.show();
  //     });
  //   });
  // }

  show() {
    if (this.container != null) {
      if (this.tourService.guideTour.isActive()) {
        //this.activeTour = true;
        //this.firstVisorStep = true;
      }
      this.container.nativeElement.style.display = 'block';
      this.cdr.detectChanges();
      this.sanitizeLocation();
      setTimeout(() => {
        this.sanitizeLocation();
      }, 100);
      //this.tourService.afterViewInitVisorTour();
    }
  }

  hide() {

    if (this.container != null) {
      this.container.nativeElement.style.display = 'none';

      //this.tourService.checkVisorClose(true);
      //this.activeTour = false;
    }
    this.closeVisorEmitter.emit()
    // this.close.emit();
    this.layout = { rows: 1, columns: 1 };
    this.cornerstoneDirectives.forEach((d) => {
      d.resetCache();
    });
  }

  playClip() {
    // console.log('this.isLayoutActive', this.isLayoutActive);
    if (!this.isLayoutActive) {
      this.configService.getConfig().then(c => {
        if (c.simple_viewer_cinema_interval != null) {
          this.cornerstoneDirectives[0].playClip(c.simple_viewer_cinema_interval);
        } else {
          this.cornerstoneDirectives[0].playClip()
        }
      })
    }
  }

  stopClip() {
    if (!this.isLayoutActive) {
      this.cornerstoneDirectives[0].stopClip();
    }
  }


  loadGridImages(grid: { rows: number, columns: number }, studyUID: string, routes: string[]): Promise<void> {
    // TODO arreglar esto, que no funciona. Nadie lo pide y nadie lo quiere usar
    return new Promise((resolve, reject) => {
      resolve()
      // const promises: Promise<void>[] = [];
      // for (let i = 0; i < grid.rows * grid.columns; i++) {
      //   const image = routes[i];
      //   const directive = this.cornerstoneDirectives[i];
      //   promises.push(new Promise((resolveSub, rejectSub) => {
      //     directive.loadSingleImage(studyUID, image).then(() => {
      //       this.toolSynchronizer.addToSynchronizer({ imageIds: [directive.currentImage.imageId] }, directive.element);
      //       resolveSub();
      //     });
      //   }))
      // }
      // Promise.all(promises).then(() => {
      //   this.activateTools();
      //   this.show();
      //   resolve();
      // }).catch(error => {
      //   console.error(error);
      //   reject();
      // })

    })
  }

  setGrid(rows: number, columns: number) {
    if (this.container.nativeElement.style.display == 'block')
      alert('Establece el grid antes de cargar imágenes');
    else
      this.layout = { rows, columns };
    this.cdr.detectChanges();
  }

  removeGrid() {
    this.layout = { rows: 1, columns: 1 };
  }

  getClassForCols() {
    return `col-${12 / this.layout.columns}`;
  }

  getStyleForRows() {
    return { height: `${100 / this.layout.rows}%` }
  }

  activateAdvancedMode() {
    if (!this.isPageSmall) {
      this.advancedMode = true;
      this.expandableTools = [WindowingTools, RotationTools, PanZoomTools, ROITools, /*DrawingTools, SpineTools*/];
    } else {
      this.advancedMode = true;
      this.expandableTools = [WindowingTools, RotationTools, PanZoomTools, ROITools, /*DrawingTools, SpineTools*/];
      let rotateTool = RotationTools.tools.find(t => t.tool == CornerstoneTools.Rotate)
      if (rotateTool != null) {
        rotateTool.disabled = true; // Deshabilito la rotación en móvil
      }
    }
  }

  clickExpandableTool(func: any, args: any) {
    switch (args.length) {
      case 0:
        // @ts-ignore
        this[func]();
        break;
      case 1:
        // @ts-ignore
        this[func](args[0]);
        break;
      case 2:
        // @ts-ignore
        this[func](args[0], args[1]);
        break;
      case 3:
        // @ts-ignore
        this[func](args[0], args[1], args[2]);
        break;
      case 4:
        // @ts-ignore
        this[func](args[0], args[1], args[2], args[3]);
        break;
    }
    this.collapseAll();
  }

  selectExpandableTool(exp: ExpandableTool, index: number) {
    exp.selectedIndex = index;
  }

  showExpandableTool(expandableTool: ExpandableTool) {
    if (!expandableTool.show) {
      setTimeout(() => {
        expandableTool.show = !expandableTool.show;
      }, 15);
    }
  }

  collapseAll(evt?: Event) {
    if (evt != null) {
      evt.preventDefault();
    }
    this.collapseTools();
    this.contextMenu.close();
  }

  collapseTools() {
    this.expandableTools.forEach(ex => {
      ex.show = false;
    })
  }

  // invert image
  public invertImage() {
    this.cornerstoneDirectives.forEach(d => {
      d.invert();
    })
  }

  // Flip image
  public flipImage(orientation: 'h' | 'v') {
    this.cornerstoneDirectives.forEach(d => {
      if (orientation == 'h') {
        d.hflip()
      }
      if (orientation == 'v') {
        d.vflip()
      }
    })
  }

  public rotate(deg: number) {
    this.cornerstoneDirectives.forEach(d => {
      d.rotate(deg);
    })
  }

  // reset image
  public resetImage() {
    this.cornerstoneDirectives.forEach(d => {
      d.reset();
    })
  }

  // toggleLock() {
  //   console.log('toggleLock');

  //   this.isLocked = !this.isLocked;
  //   if (this.isLocked) {
  //     this.cornerstoneDirectives.forEach(d => {
  //       d.activateZoomWithMouseWheel();
  //     })
  //   } else {
  //     this.cornerstoneDirectives.forEach(d => {
  //       d.activateScrollWithMouseWheel();
  //     })
  //   }
  // }

  onStartMouseDown(event: MouseEvent) {
    this.contextMenu.close();
    if (event.button == 2)
      this.auxClickOrigin = { x: event.clientX, y: event.clientY, time: new Date().getTime() };
  }

  onRightClick(event: any) {
    const deviation = Math.abs(this.auxClickOrigin.x - event.clientX) + Math.abs(this.auxClickOrigin.y - event.clientY);
    const timeDeviation = new Date().getTime() - this.auxClickOrigin.time;
    if (deviation <= 5 && timeDeviation < 350 && this.advancedMode) {
      setTimeout(() => {
        this.contextMenu.open(event);
        // this.contextMenu.open({ x: event.offsetX, y: event.offsetY });
      }, 50);
    }
  }

  hammerIt(element: HTMLElement) {
    const hammertime = new Hammer(element, {});
    hammertime.on('doubletap pan pinch panend pinchend', (ev) => {
      console.log('element', element);

    });
  }

  showVisorHelp() {

    this.startBasicVisorTour();

    setTimeout(() => {
      this.tourService.guideTour.start();
    }, 100)
  }

  startBasicVisorTour() {

    this.tourService.initDesktopTour();

    this.tourService.guideTour.addSteps(
      [
        {
          id: "btn-1",
          attachTo: {
            //element: "#visor-container > div.h-100.w-100 > div > div > canvas",
            element: "#visor-container > div.h-100.w-100 > div > div",
            on: "right"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                this.tourService.deleteAllSteps(this.tourService.guideTour.steps.length);
                this.tourService.guideTour.complete();

              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                this.tourService.guideTour.next();
              }
            }
          ],
          text: "Este es el visor. En el podemos manipular las diferentes imágenes del estudio",
          when: {
            show() {
              if (Shepherd.activeTour != undefined) {
                const currentStep = Shepherd.activeTour?.getCurrentStep();
                if (currentStep != null) {
                  const currentStepElement = currentStep?.getElement();
                  if (currentStepElement != null) {

                    //------------- AQUI METO LA CABECERA -------------------------
                    /*currentStepElement.style['margin-left'] = '30px';
                    currentStepElement.style['margin-top'] = '30px';
    
                    const header = currentStepElement?.querySelector('.shepherd-header');
                    const progress = document.createElement('span');
                    progress.style['margin-right'] = '100px';
                    progress.style['color'] = '#FFFFFF';
                    progress.innerText = `${Shepherd.activeTour?.steps.indexOf(currentStep) + 1}/${Shepherd.activeTour?.steps.length}`;
                    header?.insertBefore(progress, currentStepElement.querySelector('.shepherd-cancel-icon'));*/


                    //------------- AQUI METO LAS IMAGENES -------------------------
                    // Crear el contenedor principal
                    const gridContainer = document.createElement('div');
                    gridContainer.classList.add('grid-container');
                    currentStepElement.querySelector("#visor-container > div.h-100.w-100 > div > div")?.classList.add("custom-highlight");

                    // Array de datos para las imágenes y los textos
                    const imageData = [
                      { src: 'assets/img/intensidades.png', text: 'Ventanado' },
                      { src: 'assets/img/despla.png', text: 'Mover imagen' },
                      { src: 'assets/img/zoom.png', text: 'Imagen: Ampliar/Desampliar' },
                      { src: 'assets/img/zoom.png', text: 'Serie: Cambiar de imagen' }
                    ];

                    // Recorrer los datos y crear los elementos correspondientes
                    imageData.forEach(data => {
                      // Crear el div para cada item de la cuadrícula
                      const gridItem = document.createElement('div');
                      gridItem.classList.add('grid-item');

                      // Crear la imagen
                      const image = document.createElement('img');
                      image.src = data.src;
                      image.alt = 'Imagen';

                      // Crear el párrafo para el texto
                      const paragraph = document.createElement('p');
                      paragraph.innerText = data.text;

                      // Agregar la imagen y el párrafo al div del item
                      gridItem.appendChild(image);
                      gridItem.appendChild(paragraph);

                      // Agregar el item al contenedor principal
                      gridContainer.appendChild(gridItem);
                    });

                    const insertionPoint = document.getElementById('btn-1-description');
                    insertionPoint?.insertBefore(gridContainer, insertionPoint.querySelector('.shepherd-text'));

                    // AQUI ELIMINO LA X DE PARA CERRAR LA VENTANA
                    /*const cancelIcon = currentStepElement.querySelector('.shepherd-cancel-icon');
                    if (cancelIcon) {
                      cancelIcon.remove();
                    }*/

                    //--------------------
                  }
                }
              }
            }
          }
        }, 
        {
          id: "btn-2",
          attachTo: {
            element: "#top-banner",
            on: "bottom"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                this.tourService.deleteAllSteps(this.tourService.guideTour.steps.length);
                this.tourService.guideTour.complete();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                this.tourService.guideTour.back();
              }
  
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                this.showExpandableTool(WindowingTools);
                this.tourService.guideTour.next();
  
              }
            }
          ],
          text: "Este es el menú con las herramientas",
  
        },
        {
          id: "btn-3",
          attachTo: {
            element: '#top-banner > div:nth-child(3) > div > div',
            on: "right"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                this.collapseTools();
                this.tourService.deleteAllSteps(this.tourService.guideTour.steps.length);
                this.tourService.guideTour.complete();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                this.collapseTools();
                this.tourService.guideTour.back();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                this.collapseTools();
                this.showExpandableTool(RotationTools);
                this.tourService.guideTour.next();
  
              }
            }
          ],
          text: "Ajustes de la imagen",
        },
        {
          id: "btn-4",
          attachTo: {
            element: '#top-banner > div:nth-child(4) > div > div',
            on: "right"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                this.collapseTools();
                this.tourService.deleteAllSteps(this.tourService.guideTour.steps.length);
                this.tourService.guideTour.complete();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                this.collapseTools();
                this.showExpandableTool(WindowingTools);
                this.tourService.guideTour.back();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                this.collapseTools();
                this.showExpandableTool(PanZoomTools);
                this.tourService.guideTour.next()
  
              }
            }
          ],
          text: "Trasformación de la imagen",
        },
        {
          id: "btn-5",
          attachTo: {
            element: '#top-banner > div:nth-child(5) > div > div',
            on: "right"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                this.collapseTools();
                this.tourService.deleteAllSteps(this.tourService.guideTour.steps.length);
                this.tourService.guideTour.complete();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                this.collapseTools();
                this.showExpandableTool(RotationTools);
                this.tourService.guideTour.back();
  
              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                this.collapseTools();
                this.showExpandableTool(ROITools);
                this.tourService.guideTour.next()
  
              }
            }
          ],
          text: "Opciones básicas",
        },
        {
          id: "btn-6",
          attachTo: {
            element: '#top-banner > div:nth-child(6) > div > div',
            on: "right"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Omitir",
              action: () => {
                this.collapseTools();
                this.tourService.deleteAllSteps(this.tourService.guideTour.steps.length);
                this.tourService.guideTour.complete();
              }
            },
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                this.collapseTools();
                this.showExpandableTool(PanZoomTools);
                this.tourService.guideTour.back();
  
              }
            },
            {
              classes: 'tour-round-button',
              text: "Siguiente",
              action: () => {
                this.collapseTools();
                this.tourService.guideTour.next();
              }
            }
          ],
          classes: "shepherd-text tour-container",
          text: "Herramientas DICOM de anotación",
        },
        {
          id: "btn-7",
          attachTo: {
            element: '#top-banner > div.my-btn-group.collapsable-tool-btn-container.ms-2',
            on: "bottom"
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Atrás",
              action: () => {
                this.showExpandableTool(ROITools);
                this.tourService.guideTour.back();
  
              }
            },
            {
              classes: 'tour-round-button',
              text: "Finalizar",
              action: () => {
                this.tourService.guideTour.complete();
              }
            }
          ],
          text: "Pulsando este botón devolverás la imagen a su estado original",
        }
      ]

    )


  }


  openVisor() {
    if (this.bookService.currentBook != null) {
      if (this.bookService.currentBook.pages[1].bookImages[0].dicomFile != null) {

        //Obtenemos el instance de la imagen, para poder abrirla en el visor
        let str = this.bookService.currentBook.pages[1].bookImages[0].dicomFile;
        let lastSlashIndex = str.lastIndexOf('/');
        let dcmIndex = str.lastIndexOf('.dcm');
        let instanceUID = str.substring(lastSlashIndex + 1, dcmIndex);

        this.loadImage(this.bookService.currentBook?.studyUIDs[0], instanceUID);
        this.activateAdvancedMode();
      }
    }
  }

  addVisorSteps() {

    this.tourService.guideTour.addSteps([
      {
        id: "btn-3",
        attachTo: {
          //element: "#visor-container > div.h-100.w-100 > div > div > canvas",
          element: "#visor-container > div.h-100.w-100 > div > div",
          on: "right"
        },
        buttons: [
          {
            classes: 'tour-round-button',
            text: "Omitir",
            action: () => {
              ($("#flipbook") as any).turn("page", 1);
              this.hide();
              this.tourService.deleteAllSteps(this.tourService.guideTour.steps.length);
              this.tourService.guideTour.complete();

            }
          },
          {
            classes: 'tour-round-button',
            text: "Atrás",
            action: () => {
              this.hide();
              this.tourService.guideTour.back();
            }
          },
          {
            classes: 'tour-round-button',
            text: "Siguiente",
            action: () => {
              this.tourService.guideTour.next();
            }
          }
        ],
        text: "Este es el visor. En el podemos manipular las diferentes imágenes del estudio",
        when: {
          show() {
            if (Shepherd.activeTour != undefined) {
              const currentStep = Shepherd.activeTour?.getCurrentStep();
              if (currentStep != null) {
                const currentStepElement = currentStep?.getElement();
                if (currentStepElement != null) {

                  //------------- AQUI METO LA CABECERA -------------------------
                  /*currentStepElement.style['margin-left'] = '30px';
                  currentStepElement.style['margin-top'] = '30px';
  
                  const header = currentStepElement?.querySelector('.shepherd-header');
                  const progress = document.createElement('span');
                  progress.style['margin-right'] = '100px';
                  progress.style['color'] = '#FFFFFF';
                  progress.innerText = `${Shepherd.activeTour?.steps.indexOf(currentStep) + 1}/${Shepherd.activeTour?.steps.length}`;
                  header?.insertBefore(progress, currentStepElement.querySelector('.shepherd-cancel-icon'));*/


                  //------------- AQUI METO LAS IMAGENES -------------------------
                  // Crear el contenedor principal
                  const gridContainer = document.createElement('div');
                  gridContainer.classList.add('grid-container');
                  currentStepElement.querySelector("#visor-container > div.h-100.w-100 > div > div")?.classList.add("custom-highlight");

                  // Array de datos para las imágenes y los textos
                  const imageData = [
                    { src: 'assets/img/intensidades.png', text: 'Ventanado' },
                    { src: 'assets/img/despla.png', text: 'Mover imagen' },
                    { src: 'assets/img/zoom.png', text: 'Imagen: Ampliar/Desampliar' },
                    { src: 'assets/img/zoom.png', text: 'Serie: Cambiar de imagen' }
                  ];

                  // Recorrer los datos y crear los elementos correspondientes
                  imageData.forEach(data => {
                    // Crear el div para cada item de la cuadrícula
                    const gridItem = document.createElement('div');
                    gridItem.classList.add('grid-item');

                    // Crear la imagen
                    const image = document.createElement('img');
                    image.src = data.src;
                    image.alt = 'Imagen';

                    // Crear el párrafo para el texto
                    const paragraph = document.createElement('p');
                    paragraph.innerText = data.text;

                    // Agregar la imagen y el párrafo al div del item
                    gridItem.appendChild(image);
                    gridItem.appendChild(paragraph);

                    // Agregar el item al contenedor principal
                    gridContainer.appendChild(gridItem);
                  });

                  const insertionPoint = document.getElementById('btn-3-description');
                  insertionPoint?.insertBefore(gridContainer, insertionPoint.querySelector('.shepherd-text'));

                  // AQUI ELIMINO LA X DE PARA CERRAR LA VENTANA
                  /*const cancelIcon = currentStepElement.querySelector('.shepherd-cancel-icon');
                  if (cancelIcon) {
                    cancelIcon.remove();
                  }*/

                  //--------------------
                }
              }
            }
          }
        }
      },
      {
        id: "btn-4",
        attachTo: {
          element: "#top-banner",
          on: "bottom"
        },
        buttons: [
          {
            classes: 'tour-round-button',
            text: "Omitir",
            action: () => {
              ($("#flipbook") as any).turn("page", 1);
              this.hide();
              this.tourService.deleteAllSteps(this.tourService.guideTour.steps.length);
              this.tourService.guideTour.complete();
            }
          },
          {
            classes: 'tour-round-button',
            text: "Atrás",
            action: () => {
              this.tourService.guideTour.back();
            }

          },
          {
            classes: 'tour-round-button',
            text: "Siguiente",
            action: () => {
              this.showExpandableTool(WindowingTools);
              this.tourService.guideTour.next();

            }
          }
        ],
        text: "Este es el menú con las herramientas",

      },
      {
        id: "btn-5",
        attachTo: {
          element: '#top-banner > div:nth-child(3) > div > div',
          on: "right"
        },
        buttons: [
          {
            classes: 'tour-round-button',
            text: "Omitir",
            action: () => {
              this.collapseTools();
              this.hide();
              ($("#flipbook") as any).turn("page", 1);
              this.tourService.deleteAllSteps(this.tourService.guideTour.steps.length);
              this.tourService.guideTour.complete();
            }
          },
          {
            classes: 'tour-round-button',
            text: "Atrás",
            action: () => {
              this.collapseTools();
              this.tourService.guideTour.back();
            }
          },
          {
            classes: 'tour-round-button',
            text: "Siguiente",
            action: () => {
              this.collapseTools();
              this.showExpandableTool(RotationTools);
              this.tourService.guideTour.next();

            }
          }
        ],
        text: "Ajustes de la imagen",
      },
      {
        id: "btn-6",
        attachTo: {
          element: '#top-banner > div:nth-child(4) > div > div',
          on: "right"
        },
        buttons: [
          {
            classes: 'tour-round-button',
            text: "Omitir",
            action: () => {
              this.collapseTools();
              this.hide();
              ($("#flipbook") as any).turn("page", 1);
              this.tourService.deleteAllSteps(this.tourService.guideTour.steps.length);
              this.tourService.guideTour.complete();
            }
          },
          {
            classes: 'tour-round-button',
            text: "Atrás",
            action: () => {
              this.collapseTools();
              this.showExpandableTool(WindowingTools);
              this.tourService.guideTour.back();
            }
          },
          {
            classes: 'tour-round-button',
            text: "Siguiente",
            action: () => {
              this.collapseTools();
              this.showExpandableTool(PanZoomTools);
              this.tourService.guideTour.next()

            }
          }
        ],
        text: "Trasformación de la imagen",
      },
      {
        id: "btn-7",
        attachTo: {
          element: '#top-banner > div:nth-child(5) > div > div',
          on: "right"
        },
        buttons: [
          {
            classes: 'tour-round-button',
            text: "Omitir",
            action: () => {
              this.collapseTools();
              this.hide();
              ($("#flipbook") as any).turn("page", 1);
              this.tourService.deleteAllSteps(this.tourService.guideTour.steps.length);
              this.tourService.guideTour.complete();
            }
          },
          {
            classes: 'tour-round-button',
            text: "Atrás",
            action: () => {
              this.collapseTools();
              this.showExpandableTool(RotationTools);
              this.tourService.guideTour.back();

            }
          },
          {
            classes: 'tour-round-button',
            text: "Siguiente",
            action: () => {
              this.collapseTools();
              this.showExpandableTool(ROITools);
              this.tourService.guideTour.next()

            }
          }
        ],
        text: "Opciones básicas",
      },
      {
        id: "btn-8",
        attachTo: {
          element: '#top-banner > div:nth-child(6) > div > div',
          on: "right"
        },
        buttons: [
          {
            classes: 'tour-round-button',
            text: "Omitir",
            action: () => {
              this.collapseTools();
              this.hide();
              ($("#flipbook") as any).turn("page", 1);
              this.tourService.deleteAllSteps(this.tourService.guideTour.steps.length);
              this.tourService.guideTour.complete();
            }
          },
          {
            classes: 'tour-round-button',
            text: "Atrás",
            action: () => {
              this.collapseTools();
              this.showExpandableTool(PanZoomTools);
              this.tourService.guideTour.back();

            }
          },
          {
            classes: 'tour-round-button',
            text: "Siguiente",
            action: () => {
              this.collapseTools();
              this.tourService.guideTour.next();
            }
          }
        ],
        classes: "shepherd-text tour-container",
        text: "Herramientas DICOM de anotación",
      },
      {
        id: "btn-9",
        attachTo: {
          element: '#top-banner > div.my-btn-group.collapsable-tool-btn-container.ms-2',
          on: "bottom"
        },
        buttons: [
          {
            classes: 'tour-round-button',
            text: "Omitir",
            action: () => {
              this.hide();
              ($("#flipbook") as any).turn("page", 1);
              this.tourService.deleteAllSteps(this.tourService.guideTour.steps.length);
              this.tourService.guideTour.complete();
            }
          },
          {
            classes: 'tour-round-button',
            text: "Atrás",
            action: () => {
              this.showExpandableTool(ROITools);
              this.tourService.guideTour.back();

            }
          },
          {
            classes: 'tour-round-button',
            text: "Siguiente",
            action: () => {

              this.hide();
              ($("#flipbook") as any).turn("page", 1);
              this.addLastTourStepEmitter.emit();
              setTimeout(() => {
                this.tourService.guideTour.next();
              }, 200);

            }
          }
        ],
        text: "Pulsando este botón devolverás la imagen a su estado original",
      }
      /*{
        id: "btn-10",
        attachTo: {
          element: "#top-banner > button.btn.btn-close.p-0.px-3.ng-star-inserted",
          on: "right-start"
        },
        buttons: [
          {
            classes: 'tour-round-button',
            text: "Omitir",
            action: () => {
              this.hide();
              ($("#flipbook") as any).turn("page", 1);
              this.tourService.deleteAllSteps(this.tourService.guideTour.steps.length);
              this.tourService.guideTour.complete();
            }
          },
          {
            classes: 'tour-round-button',
            text: "Atrás",
            action: () => {
              this.tourService.guideTour.back();
            }
          },
          {
            classes: 'tour-round-button',
            text: "Siguiente",
            action: () => {
              
                this.hide();
                ($("#flipbook") as any).turn("page", 1);
                this.addLastTourStepEmitter.emit();
                setTimeout(() => {
                  this.tourService.guideTour.next();
                }, 200);

            }
          }
        ],
        text: "Interactua con el visor o pulsa \"Siguiente\" para seguir con el tour",

      }*/
    ])

  }
}
